<template>
    <div class="modal" tabindex="-1" role="dialog" aria-hidden="true" v-show="isGlobalModalActive"
         @click.self="hideGlobalModal">
        <div class="modal-dialog modal-dialog-centered" role="document" :style="{
            width: modalWidth
        }">
            <div class="modal-content">
                <div class="modal-header">
                    <h3 class="modal-title m-0">
                        {{ modalTitle }}
                    </h3>
                    <i class="fas fa-times-circle" @click="hideGlobalModal"></i>
                </div>
                <div class="modal-body" v-html="modalContent"></div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from "vuex"

    export default {
        name: 'global-modal',
        computed: {
            ...mapGetters({
                modalTitle: 'getModalTitle',
                modalWidth: 'getModalWidth',
                modalContent: 'getModalContent',
                isGlobalModalActive: 'isGlobalModalActive'
            })
        },
        methods: {
            ...mapActions({
                hideGlobalModal: 'hideGlobalModal',
                showGlobalModal: 'showGlobalModal',
            })
        },
    }
</script>

<style scoped lang="scss">
    @import "./../../../scss/variables.scss";

    .modal {
        display: block;
        background: rgba(0, 0, 0, .88);
        z-index: 11000;
        overflow-y: auto;

        .modal-dialog {
            max-width: none;
        }

        .modal-content {
            .modal-header {
                border-bottom: 0;
            }
            .modal-body {
                overflow-y: scroll;
                padding: 20px 60px;
            }
        }

        .fas {
            cursor: pointer;
            color: $primary;
            transition: color .3s ease-in-out;
            font-size: 1.75rem;

            &:hover {
                color: lighten($primary, 20)
            }
        }
    }

    @media only screen and (max-width: 480px) {
        .modal {
            .modal-dialog {
                max-width: none;
                width: 100% !important;
            }

            .modal-content {
                .modal-body {
                    padding: 20px 20px 120px 20px;
                }
            }
        }
    }
</style>